export const RoomDataNotFound = () => {
    return (
        <div>
            <h3>部屋情報が見つかりませんでした。</h3>
        </div>
    )
}